import React from 'react';
import { Form2 } from '../../primitives/Forms2';
import { FormGrid, LoadingIndicator, OccupyFreeSpace, SimpleDialog } from '../../primitives';
import { useCalculatorConfigsList } from '../storage/useCalculatorConfigsList';
import { FormControlsForFields, TableForFields } from '../../schemed';
import { StrippedIconButton } from '../../primitives/StrippedButtons';
import { Add } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useRouteMatch } from 'react-router-dom';

interface Props {
  apiPath: string;
}

export const CalculatorConfigsListPage = ({ apiPath }: Props) => {
  const data = useCalculatorConfigsList(apiPath);
  const { url } = useRouteMatch();

  return (
    <>
      <Form2
        noTitle
        background="panel"
        fitFullHeight
        headerItems={
          <>
            <Typography variant="h4">Конфигурации калькулятора</Typography>
            <OccupyFreeSpace />
            {!!data.isLoading && <LoadingIndicator sizeVariant="s" />}
            <StrippedIconButton
              onClick={() => data.newRecord.startEditing()}
              color="primary"
            >
              <Add />
            </StrippedIconButton>
          </>
        }
      >
        <TableForFields
          stickyHeader
          data={data.data}
          fields={[
            ["title"],
            ["description"],
            ["created_at", { utcToLocal: true }],
            ["created_by", { utcToLocal: true }],
          ]}
          schema={data.schema}
          fieldLink={(f: any) => {
            if (f === "title") {
              return (r: any) => `${url.replace(/\/$/, '')}/${r._id}`;
            }
          }}
        />
      </Form2>

      <SimpleDialog
        {...data.newRecord.dialog}
        dialogTitle="Создать"
        noFullscreen
        save={() => data.newRecord.save()}
      >
        {!!data.newRecord.item && (
          <FormGrid columns="1fr">
            <FormControlsForFields
              data={data.newRecord.item}
              onChange={(o: any, c: any) => data.newRecord.update(c)}
              fields={[
                ["title", { controlProps: { autoFocus: true } }],
                ["description", { controlProps: { multiline: true, rows: 3 } }],
              ]}
              schema={data.schema}
            />
          </FormGrid>
        )}
      </SimpleDialog>
    </>
  );
};
